import { render, staticRenderFns } from "./StartupListTopNav.vue?vue&type=template&id=4246a9de&"
import script from "./StartupListTopNav.vue?vue&type=script&lang=js&"
export * from "./StartupListTopNav.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports